import { render, staticRenderFns } from "./NewGroupModal.vue?vue&type=template&id=66f71e7b&scoped=true"
import script from "./NewGroupModal.vue?vue&type=script&lang=js"
export * from "./NewGroupModal.vue?vue&type=script&lang=js"
import style0 from "./NewGroupModal.vue?vue&type=style&index=0&id=66f71e7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f71e7b",
  null
  
)

export default component.exports